const isServer = typeof window === 'undefined';
export const serverOrClient = {
  isServer,
  isClient: !isServer,
  global: isServer ? global : window
};
//# sourceMappingURL=server-or-client.js.map